import { useEffect, useState } from "react";

const LIGHT_THEME = "light";
const DARK_THEME = "dark";

export const useDarkMode = () => {
  const [theme, setTheme] = useState(LIGHT_THEME);
  const [componentMounted, setComponentMounted] = useState(false);

  const setMode = (mode) => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("theme", mode);
    }
    setTheme(mode);
  };

  const toggleTheme = () => {
    if (theme === LIGHT_THEME) {
      setMode(DARK_THEME);
    } else {
      setMode(LIGHT_THEME);
    }
  };

  useEffect(() => {
    const getInitialTheme = () => {
      if (typeof window !== "undefined") {
        const localTheme = window.localStorage.getItem("theme");
        if (localTheme) {
          return localTheme;
        }
        if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
          return DARK_THEME;
        }
      }
      return LIGHT_THEME;
    };

    const initialTheme = getInitialTheme();
    setTheme(initialTheme);
    setComponentMounted(true);
  }, []);

  return [theme, toggleTheme, componentMounted];
};